import { AppThunk } from "./store";
import { setSelectWalletModal } from "./modalSlice";

export const setSelectWalletModalStatus =
  (status: boolean): AppThunk =>
  async (dispatch) => {
    dispatch(setSelectWalletModal(status));
  };
